import { render } from "./LimitsManage.vue?vue&type=template&id=0cf6373d&scoped=true"
import script from "./LimitsManage.vue?vue&type=script&lang=js"
export * from "./LimitsManage.vue?vue&type=script&lang=js"

import "./LimitsManage.vue?vue&type=style&index=0&id=0cf6373d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf6373d"]])

export default __exports__